import { Button, spacingHelper, typographyHelper, paletteHelper } from '@property.com.au/ui-kit';
import { FunctionComponent } from 'react';
import { ProptrackLogoBrickSource } from '../ProptrackLogoBrickSource/ProptrackLogoBrickSource';
import { styled } from 'styled-components';

interface VGDisclaimerFooter {
  onDisclaimerLinkClick?: () => void;
}

const DisclaimerFooter = styled.div`
  padding: ${spacingHelper('medium')} 0;
`;

const Disclaimer = styled.p`
  ${typographyHelper('body02')}
  color: ${paletteHelper('textSecondary')};
`;

const DisclaimerLinkButton = styled(Button).attrs(() => ({ variant: 'link-primary' }))`
  ${typographyHelper('body02')}
  display: inline-block;
  text-align: left;
`;

const StyledProptrackLogoBrickSource = styled(ProptrackLogoBrickSource)`
  margin-bottom: ${spacingHelper('extraSmall')};
`;

export const VGDisclaimerFooter: FunctionComponent<VGDisclaimerFooter> = ({
  onDisclaimerLinkClick,
}) => {
  return (
    <DisclaimerFooter>
      <StyledProptrackLogoBrickSource />
      <Disclaimer>
        This information is supplied by realestate.com.au (ABN 21 080 195 535) on behalf of
        Proptrack Pty Ltd (ABN 43 127 386 298).{' '}
        <DisclaimerLinkButton onClick={onDisclaimerLinkClick}>
          Copyright and Legal Disclaimers about Property Data
        </DisclaimerLinkButton>
      </Disclaimer>
    </DisclaimerFooter>
  );
};
